import React, { FC, Fragment } from 'react';
import {
  Datagrid,
  TextField,
  Filter,
  TextInput,
  usePermissions,
  useTranslate,
  SelectInput,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { List } from '~/layout';
import { NoPermissions, StatusField, AmountField, CurrencyAutocomplete } from '~/components/ra';
import BankAccountCreate from './BankAccountCreate';
import { statusLabel } from '~/components/StatusField';

export const l = (key: string): string => `resources.bank/accounts.${key}`;

const PnlAccountList: FC<any> = (props) => {
  const { permissions } = usePermissions();
  const classes = useStyles();

  const translate = useTranslate();
  const td = (key: string): string => translate(`utils.${key}`);
  // Only one status exists at the moment
  const statusChoices = [{ id: 'ACTIVE', name: translate(statusLabel('ACTIVE')) }];
  const t = (key: string): string => translate(l(key));
  if (!permissions) return null;
  if (!permissions?.includes('bank.account.list')) return <NoPermissions />;

  return (
    <Fragment>
      <List
        bulkActionButtons={false}
        {...props}
        sort={{ field: 'alias', order: 'ASC' }}
        actions={<BankAccountCreate permissions={permissions} />}
        name={t('translate')}
        filters={
          <Filter className={classes.form}>
            <TextInput
              label={t('bucketIdentifier')}
              source='number'
              className={classes.formControl}
              alwaysOn
            />
            <CurrencyAutocomplete
              label={t('currency')}
              source='currency'
              alwaysOn
              className={classes.formControl}
            />
            <SelectInput
              label={l('status')}
              source='status'
              choices={statusChoices}
              alwaysOn
              allowEmpty
              emptyText={td('any')}
              className={classes.formControl}
            />
          </Filter>
        }
      >
        <Datagrid rowClick='show' size='medium' selectedIds={null}>
          <TextField source='alias' label={l('alias')} />
          <TextField source='currency' label={l('currency')} />
          <AmountField source='balance' sortable={false} />
          <TextField source='description' label={l('description')} />
          <StatusField source='status' />
        </Datagrid>
      </List>
    </Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  form: {
    alignItems: 'flex-start',
    '& > div': {
      '& > div:last-child': {
        width: theme.spacing(1),
      },
    },
  },
  formControl: {
    width: 200,
  },
}));

export default PnlAccountList;
